"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upload = _interopRequireDefault(require("./upload.vue"));
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    textInfo: {
      Object: Object
    }
  },
  data: function data() {
    return {
      accept: ".xls,.xlsx",
      dialogTableVisible1: false,
      dialogVisible2: false,
      errorExcelName: 0,
      errorExcelSize: 0,
      rightExcelName: 0,
      rightExcelSize: 0
    };
  },
  methods: {
    changShow: function changShow() {
      this.dialogTableVisible1 = true;
    },
    surefilein: function surefilein() {
      var _this = this;
      var dataEx = new FormData();
      dataEx.append("file", this.excelFile);
      if (this.excelFile) {
        (0, _school.upExcelTem)(dataEx).then(function (res) {
          _this.dialogTableVisible1 = false;
          _this.$refs.excelUp.reMoveFiles();
          // this.dialogVisible2 = true;
          // this.errorExcelName = res.data.data.errorExcelName;
          // this.errorExcelSize = res.data.data.errorExcelSize;
          // this.rightExcelName = res.data.data.rightExcelName;
          // this.rightExcelSize = res.data.data.rightExcelSize;
        });
      } else {
        this.$message.error("请先导入承诺书。");
      }
    },
    cancel: function cancel() {
      this.dialogTableVisible1 = false;
    },
    successData: function successData(e) {
      this.excelFile = e.raw;
    },
    downExcel: function downExcel(e, j) {
      this.$emit("downExcel", e, j);
    },
    downLoadSymble: function downLoadSymble(e) {
      window.open(e);
    }
  },
  components: {
    ExcelUpload: _upload.default
  }
};